export default __webpack_public_path__ + "static/media/(6).23bbe16d.jpeg";